export function redirectInstalledWebApp({
  currentPath,
  rootPath,
  launchPath,
  navigatorStandalone,
  displayModeStandalone,
  replace,
}) {
  const installed = navigatorStandalone || displayModeStandalone;
  if (!installed || currentPath !== rootPath || !launchPath) return false;

  replace(launchPath);
  return true;
}
